import React from "react"
import { Check } from "lucide-react"
import Spinner from "react-bootstrap/Spinner"

/**
 * @param {{
 *   status?: "idle" | "saving" | "success" | "success-fade" | "error" | "error-fade",
 * }} props
 */
export default function AdminSaveStatusIndicator({ status = "idle" }) {
    return (
        <span className="lodge-admin-save-status" aria-live="polite">
            {status === "saving" ? (
                <Spinner animation="border" size="sm" role="status">
                    <span className="visually-hidden">Saving…</span>
                </Spinner>
            ) : null}
            {status === "success" || status === "success-fade" ? (
                <Check
                    size={14}
                    className={
                        "lodge-admin-save-status-icon lodge-admin-save-status-icon--success" +
                        (status === "success-fade" ? " lodge-admin-save-status-icon--fade-out" : "")
                    }
                    aria-hidden="true"
                />
            ) : null}
            {status === "error" || status === "error-fade" ? (
                <span
                    className={
                        "lodge-admin-save-status-icon lodge-admin-save-status-icon--error" +
                        (status === "error-fade" ? " lodge-admin-save-status-icon--fade-out" : "")
                    }
                    aria-hidden="true"
                >
                    !
                </span>
            ) : null}
        </span>
    )
}
